import { service } from '../../../../helpers/http'

export const ActionIndexTermSignatures = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'indexTermSignatures', 
		payload: payload 
	})
}

export const ActionCreateTermSignature = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'createTermSignature', 
		payload: payload 
	})
}

export const ActionUpdateTermSignature = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'updateTermSignature', 
		payload: payload 
	})
}

export const ActionDestroyTermSignature = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'destroyTermSignature', 
		payload: payload 
	})
}

export const ActionIndexTermSignatureStatus = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'indexTermSignatureStatus', 
		payload: payload 
	})
}

export const ActionShowTermSignature = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'showTermSignature',
		payload: payload,
		idAndPayload: true,
	})
}

export const ActionShowTermSignatureByAccessToken = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'showTermSignatureByAccessToken',
		payload: payload,
		idAndPayload: true,
	})
}

export const ActionUpdateTermSignatureGenerate = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'termSignatureGenerate', 
		payload: payload 
	})
}

export const ActionResendTermSignatures = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'resendTermSignatures', 
		payload: payload 
	})
}

export const ActionDestroyBatchTermSignatures = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'destroyBatchTermSignatures', 
		payload: payload 
	})
}

export const ActionGetTermSignatureNotifications = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'getTermSignatureNotifications',
		payload: payload,
		idAndPayload: true,
	})
}

export const ActionGetPendingBlockingTerms = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'getPendingBlockingTerms',
		payload: payload,
		idAndPayload: true,
	})
}

export const ActionShowTermSignatureByTeacher = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'showTermSignatureByTeacher',
		payload: payload
	})
}

export const ActionSignByTeacherOwner = ({ dispatch }, payload ) => {
	return service({
		module: 'term',
		action: 'signByTeacherOwner',
		payload: payload
	})
}

export const ActionIndexTermSignatureIndicators = ({ dispatch }, payload ) => {
	return service({
		module: 'term',
		action: 'indexTermSignatureIndicators',
		payload: payload
	})
}

export const ActionDownloadBatchTermSignatures = ({ dispatch }, payload ) => {
	// unformatResponse: resposta crua do vue-resource (body = Blob do PDF/ZIP)
	return service({
		module: 'term',
		action: 'downloadBatchTermSignatures',
		payload: payload,
		unformatResponse: true
	})
}